/**
 * Dedupes GET /api/auth/session within a short window so React 18 Strict Mode
 * (double effect invocation in development) does not produce duplicate requests.
 */
let inflight: Promise<Response> | null = null;

export function fetchAuthSession(): Promise<Response> {
  if (!inflight) {
    const p = fetch("/api/auth/session", { credentials: "include" });
    inflight = p;
    void p.finally(() => {
      setTimeout(() => {
        inflight = null;
      }, 300);
    });
  }
  return inflight;
}
